import { Image, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { OrganizationContactContextValue } from '../../../hooks/use-orgazination-contact'
import { ActivityLogPDFStyle } from './style'
import { PdfStyle } from '@reapitform/common-ui'

export const AgreementActivityLogHeader: React.FC<{ organizationData: OrganizationContactContextValue }> = ({
  organizationData,
}) => {
  const logo: string | undefined = organizationData?.logo?.link?.url

  return (
    <View fixed style={ActivityLogPDFStyle.header}>
      <View>{logo && <Image src={logo} style={ActivityLogPDFStyle.headerLogo} />}</View>
      <Text style={[ActivityLogPDFStyle.headerTitle, PdfStyle.bold]}>Activity Log</Text>
    </View>
  )
}
